// Where the doors are in the house, and where you land coming back through one.
//
// Pure geometry — no Phaser, and no config.js either, so `node --test` can load it. The
// owner's HomeScene and the visitor's VisitHomeScene both navigate by these numbers, and
// keeping them in one place is what stops the two drifting apart: they each used to measure
// the feet their own way, and a spawn that was clear of a door in one sat inside it in the
// other. The room doors themselves live in HomeScene, which can name the scenes they lead to.
import { FLOORS } from './floors.js';

// Garden door — walking-into-zone over the patio door (bounding box of Filip's traced polygon).
export const GARDEN_DOOR_ZONE = { x1: 855, y1: 240, x2: 1014, y2: 472 };

// Wyjście z domu — drzwi wejściowe po prawej (bounding box of Filip's traced polygon).
export const EXIT_DOM_ZONE = { x1: 1166, y1: 214, x2: 1226, y2: 553 };

// Floor polyline (gdzie stopy Natalki mogą stanąć — perspektywa podłogi w bg_home).
export const HOME_FLOOR_POLYLINE = FLOORS.home.polyline;   // shared with the placement floor rule

// Where you land in the hall, by the door you came through: in front of it, a step towards the
// middle of the room (owner 2026-10-03). FEET positions; `facing` is the dir8 to stand in, away
// from the door (0 right, 1 down-right, 2 down, 3 down-left, 4 left). Your own house and a
// friend's both start from this one table — the owner asked for the two to be exactly the same.
// Every spot is clear of every door zone, or you'd be sent straight back through (homeLayout.test).
export const HOME_ARRIVALS = {
  salon:         { x: 250,  feetY: 590, facing: 1 },
  kuchnia:       { x: 400,  feetY: 565, facing: 1 },
  drugie_pietro: { x: 636,  feetY: 545, facing: 2 },
  garden:        { x: 890,  feetY: 560, facing: 3 },
  front:         { x: 1060, feetY: 600, facing: 4 },
};

// The scene-start data for coming into the hall through `door` (a key of HOME_ARRIVALS).
export function homeArrival(door) {
  const a = HOME_ARRIVALS[door];
  return { spawnX: a.x, spawnFeetY: a.feetY, spawnFacing: a.facing };
}

const overlaps = (r, z) => r.x < z.x2 && r.x + r.w > z.x1 && r.y < z.y2 && r.y + r.h > z.y1;

// The bounding box of a room door, from its two bottom corners and its height.
export function roomDoorZone(door) {
  const padX = door.zone?.padX || 0;
  return {
    x1: Math.min(door.bottomL[0], door.bottomR[0]) - padX,
    x2: Math.max(door.bottomL[0], door.bottomR[0]) + padX,
    y1: Math.min(door.bottomL[1], door.bottomR[1]) - door.h,
    y2: Math.max(door.bottomL[1], door.bottomR[1]),
  };
}

// The feet box door detection uses: 30x30 at the feet, so you have to be close to a door
// rather than merely pointing at it. `feetY` must already include the room's perspective.
export function feetRectAt(x, feetY) {
  return { x: x - 15, y: feetY - 30, w: 30, h: 30 };
}

// Which door a feet rect is standing in, or null. `roomDoors` is HomeScene's ROOM_DOORS.
//   { kind: 'room', door } | { kind: 'garden' } | { kind: 'exit' } | null
export function doorAtFeet(rect, roomDoors) {
  for (const door of roomDoors) if (overlaps(rect, roomDoorZone(door))) return { kind: 'room', door };
  if (overlaps(rect, GARDEN_DOOR_ZONE)) return { kind: 'garden' };
  if (overlaps(rect, EXIT_DOM_ZONE)) return { kind: 'exit' };
  return null;
}
